import { Action } from '@ngrx/store';

export enum ActionTypes {
  GET_CHECKLIST = '[GET_CHECKLIST] Request',
  GET_CHECKLIST_SUCCESS = '[GET_CHECKLIST] Success',
  GET_CHECKLIST_FAILURE = '[GET_CHECKLIST] Failure',
  GET_CHECKLIST_TEMPLATE_REQUEST = '[GET_CHECKLIST_TEMPLATE] Request',
  GET_CHECKLIST_TEMPLATE_SUCCESS = '[GET_CHECKLIST_TEMPLATE] Success',
  GET_CHECKLIST_TEMPLATE_FAILURE = '[GET_CHECKLIST_TEMPLATE] Failure',
  GET_SHARED_CHECKLIST_TEMPLATE_REQUEST = '[GET_SHARED_CHECKLIST_TEMPLATE] Request',
  GET_SHARED_CHECKLIST_TEMPLATE_SUCCESS = '[GET_SHARED_CHECKLIST_TEMPLATE] Success',
  GET_SHARED_CHECKLIST_TEMPLATE_FAILURE = '[GET_SHARED_CHECKLIST_TEMPLATE] Failure',
  SET_CHECKLIST_TEMPLATE_NULL = '[SET_CHECKLIST_TEMPLATE] NULL',
}

export class GetChecklistRequestAction implements Action {
  readonly type = ActionTypes.GET_CHECKLIST;
  constructor(public loader: boolean, public payload?: any) {}
}

export class GetChecklistFailureAction implements Action {
  readonly type = ActionTypes.GET_CHECKLIST_FAILURE;
  constructor(public payload: { error: string }) {}
}

export class GetChecklistSuccessAction implements Action {
  readonly type = ActionTypes.GET_CHECKLIST_SUCCESS;
  constructor(public payload: any) {}
}
export class GetChecklistTemplateRequestAction implements Action {
  readonly type = ActionTypes.GET_CHECKLIST_TEMPLATE_REQUEST;
  constructor(public loader: boolean) {}
}

export class GetChecklistTemplateFailureAction implements Action {
  readonly type = ActionTypes.GET_CHECKLIST_TEMPLATE_FAILURE;
  constructor(public payload: { error: string }) {}
}

export class GetChecklistTemplateSuccessAction implements Action {
  readonly type = ActionTypes.GET_CHECKLIST_TEMPLATE_SUCCESS;
  constructor(public payload: any) {}
}

export class GetSharedChecklistTemplateRequestAction implements Action {
  readonly type = ActionTypes.GET_SHARED_CHECKLIST_TEMPLATE_REQUEST;
  constructor(public loader: boolean) {}
}

export class GetSharedChecklistTemplateFailureAction implements Action {
  readonly type = ActionTypes.GET_SHARED_CHECKLIST_TEMPLATE_FAILURE;
  constructor(public payload: { error: string }) {}
}

export class GetSharedChecklistTemplateSuccessAction implements Action {
  readonly type = ActionTypes.GET_SHARED_CHECKLIST_TEMPLATE_SUCCESS;
  constructor(public payload: any) {}
}
export class ResetChecklistNullAction implements Action {
  readonly type = ActionTypes.SET_CHECKLIST_TEMPLATE_NULL;
  constructor() {}
}

export type Actions =
  | GetChecklistTemplateRequestAction
  | GetChecklistTemplateFailureAction
  | GetChecklistTemplateSuccessAction
  | GetSharedChecklistTemplateSuccessAction
  | GetSharedChecklistTemplateFailureAction
  | GetSharedChecklistTemplateRequestAction
  | GetChecklistRequestAction
  | GetChecklistSuccessAction
  | GetChecklistFailureAction
  | ResetChecklistNullAction;
